import React from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { searchPosts } from '../../redux/actions';
import { allPostsState$ } from '../../redux/selectors';
import * as actions from '../../redux/actions';
import './style.css';
import { useRef } from 'react';

export default function PostsList() {
  const dispatch = useDispatch();
  const history = useHistory()
  const [postId, setPostId] = useState('');
  const posts = useSelector(allPostsState$);

  const searchBy = useRef(1);
  const pageNumber = useRef(1);
  const pageSize = useRef(1);


  const handleSearchPosts = (e) => {
    e.preventDefault();
    searchBy.current = e.target.elements.title.value;
    pageNumber.current = e.target.elements.pageNumber.value;
    pageSize.current = e.target.elements.pageSize.value;
    dispatch(searchPosts.sendSearchPostsRequest({
      searchBy: searchBy.current,
      pageNumber: pageNumber.current,
      pageSize: pageSize.current,
      inAdminPage: true,
    }));
  };

  const editPost = (id) => {
    history.push('/admin/dashboard/update', { id });
  }

  const deletePost = (button, selectedId = '') => {
    const confirmation = document.getElementById('confirmation');
    if (button === 'delete') {
      confirmation.style.display = 'flex';
      setPostId(selectedId);
    }

    if (button === 'cancel') {
      confirmation.style.display = 'none';
    }

    if (button === 'ok') {
      dispatch(actions.deletePost.deletePostRequest(postId));
      confirmation.style.display = 'none';
      dispatch(searchPosts.sendSearchPostsRequest({
        searchBy: searchBy.current,
        pageNumber: pageNumber.current,
        pageSize: pageSize.current,
        inAdminPage: true,
      }));
    }
  };

  return (
    <div style={{ minHeight: '495px', paddingTop: '20px' }}>
      <div className="my-3">
        <form onSubmit={handleSearchPosts} className="d-flex flex-row justify-content-center align-items-center px-3">
          <div className="input-group w-auto me-3">
            <span className="input-group-text">Title</span>
            <input id="title" type="text" className="form-control" />
          </div>
          <div className="input-group w-auto me-3">
            <span className="input-group-text">Page number</span>
            <input id="pageNumber" type="number" className="form-control" min={1} defaultValue={1} />
          </div>
          <div className="input-group w-auto me-3">
            <span className="input-group-text">Page size</span>
            <input id="pageSize" type="number" className="form-control" min={1} defaultValue={10} />
          </div>
          <button type="submit" className="btn btn-primary rounded w-auto">Search</button>
        </form>
      </div>
      <table className="table table-striped table-hover table-bordered">
        <thead className="table-primary">
          <tr className="text-center">
            <th scope="col">Category</th>
            <th scope="col">Image</th>
            <th scope="col">Title</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          {posts && posts.length > 0 ? posts.map(({ _id, category, image, title, createdAt }) => (
            <tr key={_id} className="text-center align-middle">
              <th scope="row">{category}</th>
              <td><img src={image} alt={`Product-${_id}`} height="50" /></td>
              <td>{title}</td>
              <td style={{ width: '100px' }}>
                <i title="Edit" className="btn fa fa-pencil-square-o" aria-hidden="true" onClick={() => editPost(_id)}></i>
                <i title="Delete" className="btn fa fa-trash-o" aria-hidden="true" onClick={() => deletePost('delete', _id)}></i>
              </td>
            </tr>
          ))
            : <tr className="text-center"><td colSpan="4">No records available</td></tr>}
        </tbody>
      </table>
      <div id="confirmation" className="confirmation-wrapper">
        <div className="confirmation">
          <h4 className="confirmation-title text-center">Confirmation</h4>
          <div className="text-center pt-2 pb-3">Are you sure to delete this post?</div>
          <div className="confirmation-actions">
            <button className="btn btn-sm btn-primary" onClick={() => deletePost('ok')}><span className="px-4">OK</span></button>
            <button className="btn btn-sm btn-primary" onClick={() => deletePost('cancel')}><span className="px-1">CANCEL</span></button>
          </div>
        </div>
      </div>
    </div>
  );
}